/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React, { FC, useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'
// import cheerio from 'cheerio'
import get from 'lodash/get'
import { BiRuler } from 'react-icons/bi'
import { SHOPIFY_CDN_PATH } from '../../utils/constants'
import { ProductByHandleQuery, ProductVariant } from '../../../types/storefront'

// 颜色color/尺寸size组件
interface Props {
  data: ProductByHandleQuery['product']
  // variants: any[]
  errorMsg?: string
  showSizeGuide?: boolean
  onSelectChange?: (value?: any) => any
  onOpenSizeGuide?: (value?: any) => any
}
// tie-dye-long-casual-sweatshirt
const ProductSelect: FC<Props> = ({
  data,
  showSizeGuide = true,
  onSelectChange,
  onOpenSizeGuide,
  errorMsg,
}) => {
  /** 处理 */
  function handleVariants(): any[] {
    const options = get(data, 'options[0].values', [])
    const variant = get(data, 'variants.edges')
    const result: any[] = []
    options.forEach((item: any) => {
      result.push(
        variant.filter(
          (item2: any) => item2.node.selectedOptions[0].value === item
        )
      )
    })
    return result.flat()
  }
  const variants = handleVariants()
  const router = useRouter()
  const variantid = router.query.variant // 设置id
  const { sku } = router.query
  const [sizeItem, setSizeItem] = useState<any>([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [curSelectInfo, setCurSelectInfo] = useState<ProductVariant>()
  const [classifyList, setClassifyList] = useState<any>([])
  const [hasSizeGuide, setHasSizeGuide] = useState<boolean>(false)
  const [curIndex, setCurIndex] = useState<number[]>([])
  const [curDataList, setCurDataList] = useState<{
    color: any[]
    size: any[]
  }>({ color: [], size: [] }) // 当前组合颜色与size 用于做渲染

  const isNormalData = useMemo(() => {
    let options = get(data, 'options')
    if (Array.isArray(options)) {
      options = options.filter((item: any) =>
        ['color', 'size'].includes(item?.name.toLocaleLowerCase())
      )
      return options.length > 0
    }
    return false
  }, [data?.options])

  // 分类颜色 =》 通过尺寸
  const handleClassifyColor = (name: string) => {
    const result: string[] = []
    variants
      ?.filter((item) => item.node.selectedOptions[1].value === name)
      .forEach((item) => {
        result.push(item.node.selectedOptions[0].value)
      })
    return result
  }
  // 分类尺寸 =》 通过颜色
  const handleClassifySize = (name: string) => {
    const result: string[] = []
    variants
      ?.filter((item) => item.node.selectedOptions[0].value === name)
      .forEach((item) => {
        result.push(item.node.selectedOptions[1].value)
      })
    return result
  }
  // 获取分类全部
  const handleClassifyAll = (color: string, size: string) => ({
    size: handleClassifySize(color),
    color: handleClassifyColor(size),
  })
  // 一开始处理数
  const handleClassify = () => {
    const colors = get(data, 'options[0].values', 0)
    const sizes = get(data, 'options[1].values', 0)
    const max = Math.max(colors.length, sizes.length)
    const result = []
    for (let i = 0; i < variants.length; i += max) {
      const dealResult = variants.slice(i, i + max)
      const isempty = dealResult.every(
        (item: any) => !item.node.availableForSale
      )
      result.push({
        result: dealResult,
        isempty,
        name: dealResult[0].node.selectedOptions[0].value,
      })
    }
    setClassifyList(result)
  }
  // 设置有库存的样式，获取组合
  // 尺寸对应颜色
  const handleBtnDisabled = (cidx = 0, sidx = 0) => {
    const sname = curDataList.size[sidx]
    const cname = curDataList.color[cidx]
    const result = variants.find(
      (item: any) =>
        item.node.selectedOptions[0].value === cname &&
        item.node.selectedOptions[1].value === sname
    )
    if (result) {
      return !result.node.availableForSale
    }
    return false
  }
  // 设置背景色图片
  const setColorBtnStyle = (color: string) => {
    const prefix = '/t/64/assets/'
    const colorText = color.toLocaleLowerCase().replace(/\s/g, '-')
    const colorArr = color.toLocaleLowerCase().split(' ')
    color = colorArr.length > 1 ? colorArr[1] : colorArr[0]
    color = color ?? 'white'
    return {
      backgroundImage: `url(${SHOPIFY_CDN_PATH}${prefix}${colorText}_50x.png)`,
      backgroundColor: color,
    }
  }
  // 默认选中 或者sku级别的选中
  const getSelectByVariantid = () => {
    const options = get(data, 'options')
    let selectItem: any = null
    // sku级查找，图片index查找
    if (sku) {
      selectItem = variants.find((item: any) => item.node.id === sku)
    } else if (variantid) {
      selectItem = variants.find(
        (item: any) => item.node.image.id === variantid
      )
    } else {
      selectItem = variants.find((item: any) => item.node.availableForSale)
    }
    const [citem, sitem] = selectItem
      ? selectItem.node.selectedOptions
      : variants?.[0].node.selectedOptions
    const result = handleClassifyAll(citem.value, sitem.value) as any
    setCurDataList(result as any)
    if (selectItem) {
      // const [citem, sitem] = selectItem.node.selectedOptions
      const curOpIndex: number[] = [
        result.color.indexOf(citem.value),
        result.size.indexOf(sitem.value),
      ]
      setCurIndex(curOpIndex)
      return
    }
    if (options && options.length) {
      // const result = handleClassifyAll()
      setCurIndex(Array(options.length).fill(0))
      return
    }
    setCurIndex([0])
  }
  // 查找对应图片
  const handleSwiperIndex = (): number => {
    // setTimeout(() => {})
    const oVariant = get(data, 'variants.edges', []) // 需要原始数据
    const images = get(data, 'images.edges', [])
    const vindex = oVariant.findIndex(
      (item: any) =>
        item.node.selectedOptions[0].value === curDataList.color[curIndex[0]]
    )
    let result = 0
    if (vindex > -1) {
      result = images.findIndex(
        (item: any) => item.node.id === oVariant[vindex].node.image.id
      )
    }
    return result
  }
  /** 通过color size来查找 */
  const getCurSelectPrice = () => {
    if (!data) {
      return
    }
    const resultStr: string = `${curDataList.color[curIndex[0]]} / ${
      curDataList.size[curIndex[1]]
    }`
    for (let i = 0; i < variants.length; i++) {
      if (variants[i].node.title === resultStr) {
        setCurSelectInfo(variants[i].node)
        onSelectChange?.({
          ...variants[i].node,
          swiperIndex: handleSwiperIndex(),
        })
        break
      }
    }
  }
  // 设置选中
  const handleSelectClick = (name: string, index: number, type: number = 0) => {
    if (type === 0) {
      const size = handleClassifySize(name) || []
      const sindex = size[curIndex[1]] ? curIndex[1] : 0
      setCurIndex([index, sindex])
      setCurDataList({
        ...curDataList,
        size,
      })
    } else {
      const color = handleClassifyColor(name) || []
      const cindex = color[curIndex[0]] ? curIndex[0] : 0
      setCurIndex([cindex, index])
      setCurDataList({
        ...curDataList,
        color,
      })
    }
    // getCurSelectPrice()
  }
  // 处理脏数据
  const handleDirtyDataOptions = () => {
    setCurIndex([0])
    setCurSelectInfo(variants[0].node)
    onSelectChange?.({
      ...variants[0].node,
      swiperIndex: 0,
    })
  }
  const getSizeGuideTable = ($: any, status: boolean = true) => {
    const filterData: any[] = []
    const result: any = {}
    if (status) {
      const tbody = $('.sizeChart-drawer__content tbody').eq(0).find('tr')
      for (let i = 0; i < tbody.length; i += 1) {
        if (i > 0) {
          filterData[i - 1] = []
        }
        tbody[i].children.forEach((ele: any) => {
          if (ele.name === 'td') {
            if (i > 0) {
              filterData[i - 1].push(ele.children[0].data)
            } else {
              result[ele.children[0].data.toUpperCase()] = []
            }
          }
        })
      }
      Object.keys(result).forEach((item: any, idx: number) => {
        filterData.forEach((item2: any) => {
          result[item].push(item2[idx])
        })
      })
    }
    return result
  }
  const getSizeGuideData = async () => {
    const cheerio = (await import('cheerio')).default
    const $: any = cheerio.load(get(data, 'descriptionHtml'))
    const status = !!$('.sizeChart-drawer__content').html()
    setHasSizeGuide(status)
    const body = getSizeGuideTable($, status) || {}
    const sizeItemArr = Array.from($('.sizeContainer')).map((item: any) => {
      const sizeItems: any = []
      item.children.forEach((item2: any) => {
        const titles = get(item2, 'children[1].children[0].data', '')
        const values = get(item2, 'children[1].next.data')
        if (titles && values) {
          sizeItems.push({
            titles: item2.children[1].children[0].data.replace(':', ''),
            values: item2.children[1].next.data,
          })
        }
      })
      return {
        id: item.attribs.id,
        data: sizeItems,
        body,
      }
    })
    setSizeItem(sizeItemArr)
  }
  const sizeIndex = useMemo(() => {
    if (curIndex && curIndex.length > 1 && sizeItem) {
      const id = curDataList.size[curIndex[1]].replace('/', '-')
      return sizeItem.findIndex((item: any) => item.id.indexOf(id) > -1)
    }
    return 0
  }, [curIndex, sizeItem])
  // 初始化数据
  const initialData = () => {
    if (!data) {
      return
    }
    // 处理脏数据
    if (isNormalData) {
      handleClassify() // 处理分类是否为空的
      getSelectByVariantid()
    } else {
      handleDirtyDataOptions()
    }
    // getCurSelectPrice()
    getSizeGuideData()
  }
  useEffect(() => {
    if (data) {
      initialData()
    }
  }, [])
  useEffect(() => {
    getCurSelectPrice()
  }, [curDataList, curIndex])
  return data ? (
    <div>
      {isNormalData ? (
        <>
          {curDataList.color.length > 0 && (
            <div className="variant-wrapper mt-3.5">
              <div className="text-xs min-w-full mb-2 md:text-sm">
                <span className="font-semibold">Color: </span>
                {curDataList.color[curIndex[0]]}
              </div>
              {curDataList.color.map((i: any, idx: any) => (
                <div
                  data-empty={handleBtnDisabled(idx, curIndex[1])}
                  className={`colorbtn ${
                    idx === curIndex[0] ? 'ischecked' : ''
                  } ${
                    classifyList[i]?.isempty ||
                    handleBtnDisabled(idx, curIndex[1])
                      ? 'isdisabled'
                      : ''
                  }`}
                  key={i}
                  style={setColorBtnStyle(i)}
                  onClick={() => {
                    handleSelectClick(i, idx, 0)
                  }}
                />
              ))}
            </div>
          )}
          {curDataList.size.length > 0 && (
            <div className="variant-wrapper">
              <div className="text-xs min-w-full mb-2 mt-0.5 flex justify-between items-center md:text-sm">
                <div>
                  <span className="font-semibold">Size(US) </span>
                  {/* {i.values[curOptions[idx]]} */}
                </div>
                {showSizeGuide && hasSizeGuide && (
                  <span
                    className="text-black text-xs underline inline-flex items-center cursor-pointer md:text-xs"
                    onClick={onOpenSizeGuide}
                  >
                    <BiRuler size={18} color="#000" className="mr-1" />
                    Size Guide
                  </span>
                )}
              </div>
              {curDataList.size?.map((i: any, idx: any) => (
                <div
                  className={`sizebtn ${
                    idx === curIndex[1]
                      ? 'ischecked font-semibold'
                      : `${
                          handleBtnDisabled(curIndex[0], idx)
                            ? ' isdisabled'
                            : ''
                        }`
                  }`}
                  key={i}
                  onClick={() => handleSelectClick(i, idx, 1)}
                >
                  {i}
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <></>
      )}
      {/* 尺寸说明 */}
      {sizeItem?.[sizeIndex]?.data ? (
        <div className="sizeallform flex flex-wrap items-center text-xs p-3 pb-1.5 bg-tag-grayf5">
          <div className="w-full flex pb-1.5">
            {/* { JSON.stringify(sizeItem[sizeIndex].body)} */}
            {['US', 'UK', 'EU'].map(
              (item: string) =>
                sizeItem[sizeIndex].body[item] &&
                sizeItem[sizeIndex].body[item].length > 0 && (
                  <div className="inline-flex mr-8" key={item}>
                    <span>{item} Size:</span>
                    <span className="text-black text-opacity-40 ml-2">
                      {sizeItem[sizeIndex].body[item][sizeIndex]}
                    </span>
                  </div>
                )
            )}
          </div>
          {sizeItem[sizeIndex]?.data.map((i: any, idx: number) => (
            <div
              className="flex items-center w-2/4 pb-1.5"
              key={i.values + idx}
            >
              <span>{i.titles}:</span>
              <span className="text-black text-opacity-40 ml-2">
                {i.values}
              </span>
            </div>
          ))}
        </div>
      ) : null}
      {errorMsg && (
        <div className="bg-tag-grayf6 text-tag-error mt-2.5 text-center px-3 py-1.5 text-xs border-1 border-tag-error block md:hidden">
          {errorMsg}
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}

export default ProductSelect
